(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melon-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();

    function initHero(root) {
      const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      const prev = root.querySelector('[data-hero-prev]');
      const next = root.querySelector('[data-hero-next]');
      if (slides.length < 2) return () => {};

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = root.dataset.autoplay === 'true' && !reduceMotion;
      const delay = Number(root.dataset.speed) || 6000;
      const controller = new AbortController();
      const { signal } = controller;

      let active = 0;
      let timer = null;

      function show(index) {
        active = (index + slides.length) % slides.length;
        const activeSlide = slides[active];
        if (activeSlide) {
          root.style.setProperty('--melon-hero-height', (activeSlide.dataset.bannerHeight || '65') + 'vh');
          root.style.setProperty('--melon-hero-fit', activeSlide.dataset.bannerFit || 'contain');
          root.style.setProperty('--melon-hero-position', activeSlide.dataset.bannerPosition || 'center');
        }
        slides.forEach((slide, i) => {
          const selected = i === active;
          slide.classList.toggle('is-active', selected);
          slide.inert = !selected;
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        dots.forEach((dot, i) => {
          const selected = i === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-current', selected ? 'true' : 'false');
        });
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (autoplay && !document.hidden) {
          timer = window.setInterval(() => show(active + 1), delay);
        }
      }

      function go(index) {
        show(index);
        start();
      }

      prev?.addEventListener('click', () => go(active - 1), { signal });
      next?.addEventListener('click', () => go(active + 1), { signal });
      dots.forEach((dot) => {
        dot.addEventListener('click', () => go(Number(dot.dataset.heroDot) || 0), { signal });
      });

      root.addEventListener('mouseenter', stop, { signal });
      root.addEventListener('mouseleave', start, { signal });
      root.addEventListener('focusin', stop, { signal });
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) start();
      }, { signal });
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()), { signal });

      // Touch swipe
      let startX = 0;
      let startY = 0;
      root.addEventListener('touchstart', (event) => {
        startX = event.changedTouches[0].clientX;
        startY = event.changedTouches[0].clientY;
      }, { passive: true, signal });
      root.addEventListener('touchend', (event) => {
        const dx = event.changedTouches[0].clientX - startX;
        const dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(active + (dx < 0 ? 1 : -1));
      }, { passive: true, signal });

      show(0);
      start();

      return () => {
        stop();
        controller.abort();
      };
    }

    function initAll(scope) {
      scope.querySelectorAll('[data-hero-carousel]').forEach((el) => {
        if (!instances.has(el)) instances.set(el, initHero(el));
      });
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-hero-carousel]').forEach((el) => {
        instances.get(el)?.();
        instances.delete(el);
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
